export default () => ({
  step: {

  },
  expiredStatus: null,
  limitUserStatus: false,
  limitStorageStatus: false,
})
